import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  pageContainer: (theme: Theme): SerializedStyles => css`
    label: pageContainer;

    background-color: ${theme.mui.palette.background.paper};

    padding: ${theme.mui.spacing(5)}px ${theme.mui.spacing(0)}px;

    ${theme.mui.breakpoints.up('sm')} {
      padding: ${theme.mui.spacing(5)}px ${theme.mui.spacing(0)}px;
    }

    ${theme.mui.breakpoints.up('md')} {
      padding: ${theme.mui.spacing(5)}px ${theme.mui.spacing(0)}px;
    }
  `,
};

export default styles;
